import { render, staticRenderFns } from "./personalForm.vue?vue&type=template&id=1a9928d3&"
import script from "./personalForm.vue?vue&type=script&lang=js&"
export * from "./personalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports